import { Component, OnInit, HostListener, ViewChild, ElementRef, AfterViewInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';

import { Record } from '@core/store/models/recorder.class';
// core recorder state 
import * as fromState from '@core/store/state/recorder/recorder.state';
// services
import { RecorderService } from '@core/services/recorder/recorder.service';

interface PipVideoElement extends HTMLVideoElement{
  requestPictureInPicture(): any;
  exitPictureInPicture(): any;
}
@Component({
  selector: 'core-layout-float-pip-camera-player',
  templateUrl: './pip-camera-player.component.html',
  styleUrls: ['./pip-camera-player.component.scss']
})
export class LayoutFloatPipCameraPlayerComponent implements OnInit, AfterViewInit, OnDestroy {
  // GOT html5 <video> element from template using notation #pipVideo
  @ViewChild("pipVideo") videoElement: ElementRef;
  // Initial values for the video 
  // PIP position
  public pipTop: string = '20px';
  public pipLeft: string = '20px';
  // Normal video position
  public normalTop: string = '20px';
  public normalLeft: string = '20px';

  public hasPictureInPictureSupport: boolean = false;
  public pipMode: boolean = false;

  public cameraStream: MediaStream = null;

  private isDragging = false;
  private initialX: number;
  private initialY: number;
  private currentX: number;
  private currentY: number;

  protected streamSubs: Subscription;
  protected statusSubs: Subscription;
  constructor(private recorderSrv: RecorderService) {
    // get if current user browser has picture in picture feature for this.
    this.hasPictureInPictureSupport = (('pictureInPictureEnabled' in document) && document.pictureInPictureEnabled);
  }

  ngOnInit(): void {
    // get camera stream live to play in the pip video
    this.streamSubs = this.recorderSrv.getRecordedData().subscribe((record: Record) => {
      // console.log("cam stream -->",this.cameraStream);
      this.cameraStream = record.streams.cam;
    });

    this.statusSubs = this.recorderSrv.getStatus().subscribe((status: fromState.RecorderStatus ) => {
      // console.debug(" STATUS RECORDER is ==> ",status);
      if(status == fromState.RecorderStatus.STOPPED || status == fromState.RecorderStatus.FAILED){
          // Perform action here to cancel pip
          this.pipMode = false;
          this.endPipMode();
      }
    });
  }

  ngAfterViewInit(): void {
    if(!this.hasPictureInPictureSupport)
      return;
  
    this.initPipMode();
  }

  ngOnDestroy(): void {
    this.streamSubs.unsubscribe();
    this.endPipMode();
    this.pipMode = false;  
  }

  // TODO: improve this events for dragging when no pip available
  @HostListener('mousedown', ['$event'])
  onMouseDown(event: MouseEvent) {
    this.isDragging = true;
    this.initialX = event.clientX - parseInt(this.pipLeft.replace('px', ''),10);
    this.initialY = event.clientY - parseInt(this.pipTop.replace('px', ''),10);
  }

  @HostListener('document:mouseup', ['$event'])
  onMouseUp(event: MouseEvent) {
    this.isDragging = false;
  }

  @HostListener('document:mousemove', ['$event'])
  onMouseMove(event: MouseEvent) {
    if (this.isDragging) {
      this.currentX = event.clientX - this.initialX;
      this.currentY = event.clientY - this.initialY;

      this.pipTop = this.currentY + 'px';
      this.pipLeft = this.currentX + 'px';
      this.normalTop = this.currentY + 'px';
      this.normalLeft = this.currentX + 'px';
    }
  }

  /**
   * Toggle picture in picture video if user goes back to the normal mode and want pip mode again.
   * @param video interface for PipVideoElement that brings the html5 video element here.
   */
  public togglePictureInPicture(video: PipVideoElement) {
    // check if the pip mode element is this one given.
    try {
      if (document.pictureInPictureElement === video) {
        document.exitPictureInPicture()
          // .then(() => {
          //   // console.log('Exited Picture-in-Picture');
          //   // Maybe useful later
          // });
      } else {
        video.requestPictureInPicture()
          // .then(() => {
          //   // console.log('Entered Picture-in-Picture');
          //   // Maybe useful later
          // });
      }
    } catch (error) {
      console.log(" PIP toggle error ",error)
    }
    
  }

  // NOT USED (maybe in the future to notify oversize)
  // protected onPipWindowResize() {
    // do something when the Picture-in-Picture window is resized
  // }

  /**
   * enable the vide to be played in Picture-in-Picture (pip) mode. 
   */
  private initPipMode() : void {
    // keep an eye here: if <video> is needed to check method never called without video tag present.
    if(!this.videoElement) 
      return;
    const video: PipVideoElement = this.videoElement.nativeElement;
    // video.addEventListener('loadeddata', async (e) => {
    //   if (document.pictureInPictureEnabled && document.pictureInPictureElement) {
    //     document.exitPictureInPicture();
    //   }
    //   await video.requestPictureInPicture()
    //     // .then((pictureInPictureWindow) => { // Not used here
    //     //   pictureInPictureWindow.addEventListener("resize", () => this.onPipWindowResize(), false);
    //     // });
    //   this.pipMode = true;
    // })
    video.addEventListener("leavepictureinpicture", async (event) => {
      // when the video leaves Picture-in-Picture mode
      this.pipMode = false;
    });
    video.addEventListener("enterpictureinpicture", async (event) => {
      // when the video enter Picture-in-Picture mode
      this.pipMode = true;
    });
    video.addEventListener("pictureinpictureerror", async (event) => {
      // when the video got error entering Picture-in-Picture mode
      this.pipMode = false;
      this.hasPictureInPictureSupport = false;
    });
  }

  endPipMode() : void {
    try {
      if(this.videoElement && this.hasPictureInPictureSupport)  {
        // we need to force pip exit
        const video: PipVideoElement = this.videoElement.nativeElement;
        if (document.pictureInPictureElement === video) {
          document.exitPictureInPicture();
          console.debug('Exited Picture-in-Picture');
        } else {
          console.debug('No Picture-in-Picture to end');
  
        }
      }
    } catch (error) {
      console.log(" PIP exit error ",error)
    }
    
  }

  

}
